import { Box } from "@mui/material";
import React, { ReactNode } from "react";

export interface ActionContainerProps {
    leftItems?: ReactNode;
    rightItems?: ReactNode;
    margin?: string;
}

export const ActionContainer = ({ leftItems, rightItems, margin = "1rem 0" }: ActionContainerProps) => {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" flexGrow={0} sx={{ margin, minHeight: "42px", overflow: "hidden" }}>
            <Box display="flex" alignItems="center" flexGrow={2} sx={{ width: "100%" }}>
                {leftItems}
            </Box>
            <Box display="flex" alignItems="center" flex="0 0 auto">
                {rightItems}
            </Box>
        </Box>
    );
};
